import { render, staticRenderFns } from "./CallFailCountChart.vue?vue&type=template&id=744afc89&scoped=true&"
import script from "./CallFailCountChart.vue?vue&type=script&lang=js&"
export * from "./CallFailCountChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744afc89",
  null
  
)

export default component.exports